<template>
  <header-component></header-component>
  <services-list :services="services"></services-list>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent'
import ServicesList from '@/components/ServicesList'
import services from '@/data/data.json'

export default {
  name: 'HomeView',
  components: {
    HeaderComponent,
    ServicesList
  },
  data: () => ({
    services: services
  }),
}
</script>